import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ADMIN_SERVER_BASE_URL, SITEWEB_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import { convertToBase64, errorNotify, successNotify } from "../util/functions";
import { IPartner } from "./interface";
import { IReduxState } from '../store';
import AddIcon from '@mui/icons-material/Add';
import PostDialog from '../SpiderWebSite/components/PostDialog';
import { addPartenaire } from '../store/partenaireSlice';

interface IAddProps {
  PartenaireState: IPartner;
  setPartenaireState: (x: IPartner) => void;
  setSelectedPhoto: (x: any) => void;
  image: string;
  setImage: (x: string) => void;
}


const Add = (props: IAddProps) => {

  //props
  const {
    PartenaireState,
    setPartenaireState,
    setSelectedPhoto,
    image,
    setImage
  } = props
  //redux

  //hooks
  const selectPhoto: any = useRef(null);

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setPartenaireState({ ...PartenaireState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <Grid item md={12} xs={12} sm={12}>
            <TextField
              fullWidth
              size="small"
              name="libelle"
              label="libellé partenaire"
              value={PartenaireState.libelle}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item md={12} xs={12} sm={12}>
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <Tooltip title="Charger l'image descriptive de l'actualité">
                  <Button
                    variant="outlined"
                    color="primary"
                    component="label"
                    startIcon={<ImageIcon />}
                    style={{ marginTop: 10, width: "100%" }}
                    onClick={() => {
                      selectPhoto?.current?.click();
                    }}
                  >
                    Charger le logo
                  </Button>
                </Tooltip>
                <input
                  hidden
                  multiple
                  type="file"
                  name="pieceJointe"
                  ref={selectPhoto}
                  onChange={(e: any) => {
                    const files = e.target.files[0];
                    if (files) {
                      const img = URL.createObjectURL(files);
                      setImage(img);
                      setSelectedPhoto(e.target.files[0]);
                    }
                  }}
                />
              </Grid>
              <Grid item md={6} xs={12} sm={6}>
                <img
                  src={image}
                  style={{ width: "5vw", height: "auto" }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};







export const initialState = {
  libelle: "",
  logoPartenaire: ""
}


const DialogAdd = () => {

  //redux
  const dispatch = useDispatch();

  //hooks
  const [open, setOpen] = useState<boolean>(false)
  const [addLoading, setAddLoading] = useState<boolean>(false)
  const [PartenaireState, setPartenaireState] = useState<IPartner>(initialState)
  const [photosGalerieBase64, setPhotosGalerieBase64] = useState<any>([]);
  const [selectedPhoto, setSelectedPhoto] = useState<any>({})
  const [image, setImage] = useState<string>("");

  //Ouvrir la boite de dialog 
  const onClose = () => {
    setOpen(false)
  }

  //Fermer la boite de dialog
  const handleOpenDialog = () => {
    setOpen(true)
  }


  /**
   * Permet d'enregistrer une actualité dans la base de donnée
   * @param e 
   */
  const handlePartenaireSave = async (e: any) => {
    try {
      e.preventDefault()
      setAddLoading(true)

      //Obtenir l'image qui decrit l'actualité en base 64
      const logoBase64: any = selectedPhoto ? await convertToBase64(selectedPhoto) : "";

      // Création de l'idPartenaire
      const formattedLibelle = PartenaireState?.libelle
        ? PartenaireState.libelle.replace(/ /g, '_').toUpperCase()
        : '';

      //Constituer le payload final
      const apiPayload: IPartner = {
        idPartenaire: `PART_${formattedLibelle?.toUpperCase()}`,
        ...PartenaireState,
        logoPartenaire: logoBase64
      }

      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/creerpartenaire", apiPayload);
      if (res.status === 1) {
        dispatch(addPartenaire(res.data))
        successNotify("Action effectuée avec succès");
        setAddLoading(false)
        setPartenaireState(initialState)
        setImage("")
        setPhotosGalerieBase64([])
      } else {
        errorNotify("Erreur");
        setAddLoading(false)
      }
    } catch (error) {
      setAddLoading(false)
      console.log("🚀 ~ file: Add.tsx:305 ~ handlePartenaireSave ~ error:", error)
    }
  }


  return (
    <PostDialog
      onClose={onClose}
      open={open}
      dialogContent={
        <Add
          PartenaireState={PartenaireState}
          setPartenaireState={setPartenaireState}
          setSelectedPhoto={setSelectedPhoto}
          image={image}
          setImage={setImage}
        />}
      actionFunc={handlePartenaireSave}
      title="Partenaire"
      addLoading={addLoading}
      handleOpenDialog={handleOpenDialog}
    />

  );
};
export default DialogAdd;



